/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Match_Type_RegexInputs */



/**
* | output |
* | --- |
* | "Regex Pattern" |
*
* @param {Compliance_Match_Type_RegexInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_match_type_regex = /** @type {((inputs?: Compliance_Match_Type_RegexInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Match_Type_RegexInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Regex-Muster")
	return /** @type {LocalizedString} */ ("Regex Pattern")
});